import React, { useState, useEffect } from "react";
import "../login/Login.css";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const images = [
  "./images/img4.jpg",
  "./images/img1.jpg",
  "./images/img2.jpg",
  "./images/img3.avif",
];

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    setLoading(true);
    const payload = { Email: email, Password: password };

    const validateEmail = (email) => {
      return /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(email);
    };

    if (!email) {
      toast.error("Email is required.");
      setLoading(false);
      return;
    }
    if (!validateEmail(email)) {
      toast.error("Please enter a valid email address.");
      setLoading(false);
      return;
    }
    if (!password) {
      toast.error("Password is required.");
      setLoading(false);
      return;
    }

    try {
      const result = await axios.post(
        "https://aligndesk.dropyourbusiness.com/api/login",
        payload
      );

      if (result.status === 200 && result.data.success) {
        toast.success("Login successful");
        const user = result.data.data;
        localStorage.setItem("user", JSON.stringify(user));
        localStorage.setItem("role", user.role);
        const role = localStorage.getItem("role");
        console.log("role-->",role)
        // sessionStorage.setItem("user", JSON.stringify(user)); // Store user data in sessionStorage
        // sessionStorage.setItem("role", user.role); // Store user role in sessionStorage
        if (role === "admin") {
          navigate("/admindashboard"); 
        } else {
          navigate("/dashboard");
        }
      } else {
        toast.error("Invalid email or password");
      }
    } catch (error) {
      console.error(error);
      if (error.response) {
        if (error.response.status === 401) {
          toast.error("Invalid password");
        } else {
          toast.error(error.response.data.message || "Failed to login");
        }
      } else {
        toast.error("Network error. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <ToastContainer />
      <div className="image-section">
        <img src={images[currentImageIndex]} alt="Login Illustration" />
      </div>
      <div className="form-section">
        <div className="logo">
          <img src="./images/Logo New (1).png" alt="Align Desk" />
        </div>
        <h2>Welcome Back</h2>
        <p className="login-subtitle">Log in to access your account</p>
        <div className="input-field">
          <input
            type="text"
            placeholder="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <div className="password-container">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Enter Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <span className="eye-icon" onClick={togglePasswordVisibility}>
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>
          <button className="login-button" onClick={handleLogin}>
            {loading ? (
              <div className="login-loader-container">
                <div className="login-loader"></div>
                Loading...
              </div>
            ) : (
              <>Log In</>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;
